module.exports = __webpack_public_path__ + "static/media/lightningGamesPlayed_250000_500000.5ae83fde.png";